const TeachersListDic = {
    'Title' : {
        'fa' : 'اساتید زبان انگلیسی'
    } 
}
export default TeachersListDic